<template>
  <div>
    <label>
      Please add details of the new occupier if known, or the landlord / agency
      responsible for the property.
      <SoTextarea
        class="mt-2"
        :model-value="details"
        :rules="[rules.required]"
        type="text"
        data-testid="new-occupier-details"
        @update:model-value="updateField('careOf', $event)"
      />
    </label>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import { useCurrentAccountStore } from "@/stores/currentAccount"
  import SoTextarea from "@/components/formControls/SoTextarea.vue"
  import rules from "@/validators/rules"

  export default defineComponent({
    components: {
      SoTextarea,
    },
    inheritAttrs: false,
    props: {
      modelValue: {
        type: String,
        default: () => "",
      },
    },
    emits: ["update:modelValue"],
    data() {
      return {
        current: useCurrentAccountStore(),
        isForwardAddressModalShown: false,
        details: "",
      }
    },
    computed: {
      rules() {
        return rules
      },
    },
    created() {
      if (this.modelValue) {
        this.details = this.modelValue
      }
    },
    methods: {
      updateField(fieldName: string, fieldValue: string) {
        this.details = fieldValue
        this.$emit("update:modelValue", this.details)
      },
    },
  })
</script>
